import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  Chip,
  Avatar,
  IconButton,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  CheckCircle,
  Group,
  Block,
  AccountCircle,
  Close,
  Edit,
  Delete,
  Assignment,
  VpnLock,
  Money,
  AccountBalance,
  Schedule,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { makeStyles } from "@material-ui/styles";
import { Skeleton } from "@material-ui/lab";

import { useSnackbar } from "notistack";

import {
  FinanceService,
  AdminService,
  Validator,
  hasPermission
} from "../../../../../utils/web_config";
import { useAccountTypes, useInternalAccounts } from "../../../hooks/use_hooks";
const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function InternalAccounts(props) {
  const classes = useStyles();
  const history = useHistory();

  const accountTypes = useAccountTypes();
  const internalAccounts = useInternalAccounts();

  const [accountData, setAccountData] = useState({});
  const [accounts, setAccounts] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    status: "Loading accounts....",
    loading: false,
    toggling: false,
    data: [],
  });

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [typesOpen, setTypesOpen] = useState(false);

  const [internalOpen, setInternalOpen] = useState(false);

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getAccounts(accountData.token);
  }, []);

  ///////////////

  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "organization_id",
      label: "Org id",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "user_id",
      label: "User id",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "account_number",
      label: "Acc number",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "account_name",
      label: "Account name",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "account_number_formatted",
      label: "Account number",
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "phone_number",
      label: "Phone number",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "current_balance",
      label: "Account balance",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <span>{new Validator().formatMoney(value)}</span>
        ),
      },
    },
    {
      name: "status2",
      label: "Status2",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {accounts.data[dataI].status.toLowerCase() == "enabled" ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                      <Block fontSize="small" />
                    )}
                </Avatar>
              }
              variant="outlined"
              color={
                accounts.data[dataI].status.toLowerCase() == "enabled"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(accounts.data[dataI]?.status)}
            />
          );
        },
      },
    },
  ];

  const options = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search user...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    onCellClick: (cellData, cellMeta) => {
      var acc = accounts.data[cellMeta.dataIndex];

      if(hasPermission("CAN_VIEW_INTERNAL_ACCOUNT")){
        history.push("/centrika/accounts/details", acc);
        }
 
    },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: accounts.status,
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      // <CustomAccountsToolbar
      //   selectedRows={selectedRows}
      //   displayData={displayData}
      //   setSelectedRows={setSelectedRows}
      //   toggleUser={toggleUser}
      //   openEdit={showUserEdit}
      //   toggling={accounts.toggling}
      // />
      <></>
    ),
  };
  /////////////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  ///////////////////////////////////

  const getAccounts = (token) => {
    const accsInstance = axios.create(new AdminService().getHeaders(token));

    setAccounts({ ...accounts, loading: true });

    console.log("getting accounts .....");

    accsInstance
      .get(
        new FinanceService().GET_ALL_ACCOUNTS +
        "?account_type_name=INTERNAL&per_page=500"
      )
      .then(function (response) {
        setAccounts({ ...accounts, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setAccounts({
            ...accounts,
            status: "There are no accounts available.",
          });
        } else {
          var acs = [];

          d.data.forEach((a, i) => {
            const newAcc = a;
            newAcc["status2"] = a.status;

            acs.push(newAcc);
          });

          setAccounts({
            ...accounts,
            data: acs,
          });
        }
      })
      .catch(function (error) {
        setAccounts({ ...accounts, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setAccounts({
          ...accounts,
          status: e,
        });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}

      {/* //////////////////////////////////////// */}
      <Dialog
        open={typesOpen}
        onClose={() => setTypesOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{"Account types"}</DialogTitle>
        <DialogContent>
          {accountTypes.status == "error" || accountTypes.status == "empty" ? (
            <Box p={5} display="flex" justifyContent="center">
              {accountTypes.status == "error" ? (
                <Typography>
                  Error loading account types, try to refresh
                </Typography>
              ) : (
                  <Typography>
                    There are no account types available yet.
                  </Typography>
                )}
            </Box>
          ) : (
              <List>
                {accountTypes.status != "loading"
                  ? accountTypes.data.map((tp, i) => (
                    <>
                      {i != 0 && i != accountTypes.data.length && (
                        <Divider variant="middle" />
                      )}
                      <ListItem key={i} dense>
                        <ListItemText
                          primary={tp.name}
                          secondary={tp.description}
                        />
                        <ListItemSecondaryAction>
                          <Switch
                            color="primary"
                            checked={tp.status == "ENABLED"}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                    </>
                  ))
                  : [1, 2, 3, 4, 5].map((item, i) => (
                    <ListItem key={i}>
                      <ListItemText
                        primary={
                          <Skeleton
                            variant="text"
                            width={"100%"}
                            style={{ borderRadius: 7 }}
                          />
                        }
                      />
                    </ListItem>
                  ))}
              </List>
            )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setTypesOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* ////////////////////////////// */}
      <Box display="flex">
        <Box mr={2}>
          {" "}
          <Group color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>Internal accounts</b>
        </Typography>

        <Button
          className={classes.btn}
          color="primary"
          variant="contained"
          size="medium"
          startIcon={<Assignment />}
          disableElevation
          onClick={() => setTypesOpen(true)}
        >
          Account types
        </Button>
      </Box>
      <Box mt={3} />
      {accounts.loading && <LinearProgress />}
      <MUIDataTable
        title={"List of internal accounts"}
        data={accounts.data}
        columns={columns}
        options={options}
      />
    </div>
  );
}

export default withLocalize(InternalAccounts);
